import * as React from "react";

const SvgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    fill="none"
    viewBox="0 0 48 48">
    <rect width="48" height="48" fill="#CDE4DD" rx="10"></rect>
    <path
      fill="#057953"
      d="M23.999 12.336a5.547 5.547 0 0 0-5.542 5.542c0 2.998 2.345 5.425 5.402 5.53a1 1 0 0 1 .256 0h.08199999999999999a5.53 5.53 0 0 0 5.343-5.53A5.547 5.547 0 0 0 24 12.336M29.925 26.51c-3.255-2.17-8.563-2.17-11.841 0-1.482.992-2.299 2.334-2.299 3.769s.817 2.765 2.287 3.745c1.633 1.096 3.78 1.645 5.927 1.645s4.293-.549 5.926-1.645c1.47-.992 2.287-2.322 2.287-3.769-.012-1.435-.817-2.765-2.287-3.745"></path>
  </svg>
);

export default SvgIcon;
